import React from "react";
import styles from "./SectionRow.module.css";
import VideoCard from "../VideoCard/VideoCard";

export default function SectionRow({ label, items, likes, onPlay, onToggleLike, getPct }){
  return (
    <section className={styles.section} aria-label={`${label} videos`}>
      <div className={styles.head}>
        <h2 className={styles.title}>{label}</h2>
        <div className={styles.pill}>{items.length} videos</div>
      </div>
      <div className={styles.scroll}>
        {items.map(item => (
          <VideoCard
            key={item.id}
            item={item}
            liked={!!likes[item.id]}
            onPlay={onPlay}
            onToggleLike={onToggleLike}
            progressPct={getPct(item.id)}
          />
        ))}
        {items.length===0 && (
          <div className={styles.empty} style={{minWidth:260}}>No matches. Try a different search.</div>
        )}
      </div>
    </section>
  );
}